import { Link } from '@mui/material'
import { FileEntry } from '../interfaces/File/FileEntry'

export const FileLink = ({ file }: { file: FileEntry }) => {
  return (
    <Link
      href={`${window.location.origin}/api/v1/download/${file.faila_id}/${file.sha256}`}
      {...(file.content_type === 'application/pdf'
        ? { target: '_blank', rel: 'noreferrer' }
        : { download: file.nosaukums })}
    >
      {file.nosaukums}
    </Link>
  )
}
